import { get } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { Col, Row } from "reactstrap";
import FormModal from "src/components/FormModalV2/FormModal";
import Icon, { IconName } from "src/components/Icon/Icon";
import { IApplicationComment } from "src/store/models/application.model";
import { IRootState } from "src/store/reducers";
import {
  fetchBrokerCommentOptions,
  fetchBrokerCommentsList,
  submitBrokerComment,
} from "src/store/reducers/brokerComments";
import { Container } from "../../../components/Container/Container";
import DisTable from "../../../components/TableV2/Table";
import Toast from "../../../components/Toast/Toast";
import * as S from "../../../constants/StringConstants";
import { columns } from "../BrokerCommentsWidget/CommentsColumns/CommentsColumns";
import { CommentForm } from "./CommentsForm";

const BrokerComments = () => {
  const fileTableRef = useRef<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useDispatch();
  const { id: brokerID } = useParams<{ id: string }>();

  const { selectPriorityList, userID } = useSelector((state: IRootState) => ({
    selectPriorityList: state.brokerComments.commentDetails?.selectPriorityList,
    userID: state.auth.user.userID,
  }));

  const onEdit = async (values: any) => {
    await dispatch(submitBrokerComment(brokerID, userID, values));
    if (fileTableRef.current) {
      fileTableRef.current.update();
    }
  };

  useEffect(() => {
    dispatch(fetchBrokerCommentOptions());
  }, []);

  return (
    <>
      <main className="broker-tab__wrap">
        <section className="broker-tab__container">
          <Container>
            <div className="broker-tab__form-wrap">
              <Row>
                <Col sm="9" className="doc-tab__title">
                  <h1 className="form-title">{S.BRO_COMMENTS_TITLE}</h1>
                </Col>
                <Col sm="3" align="right">
                  <FormModal<IApplicationComment>
                    values={{}}
                    onSubmit={onEdit}
                    title={S.BRO_COMMENTS_ADD_LABEL}
                    launcher={
                      <button className="button-v2 button-v2__primary broker-tab__action-button">
                        <Icon name={IconName.Plus} />
                        {S.BRO_COMMENTS_ADD_LABEL}
                      </button>
                    }>
                    <CommentForm priorityList={selectPriorityList} />
                  </FormModal>
                </Col>
              </Row>

              <Row>
                <Col className="doc-tab__table-override">
                  <DisTable<IApplicationComment>
                    columns={columns}
                    initialState={{}}
                    getRef={ft => {
                      fileTableRef.current = ft;
                    }}
                    onUpdate={async ({ page, rows, sort, query }) => {
                      setLoading(true);
                      const result: any = await dispatch(
                        fetchBrokerCommentsList({ brokerID, page, rows, sort, query }),
                      );
                      setLoading(false);
                      return {
                        total: get(result, "value.data.totalRows") as number,
                        data: get(result, "value.data.items") as IApplicationComment[],
                      };
                    }}
                  />
                </Col>
              </Row>
            </div>
          </Container>
        </section>
      </main>

      <Toast open={loading} message={S.LOADING} onClose={() => {}} />
    </>
  );
};

export default BrokerComments;
